import { Injectable, Inject } from '@angular/core';
import { Resolve, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NgxAuthService } from '@go-modules/services/auth/auth.service';
import {
	SanitizerService,
	sanitizerServiceToken
} from 'go-modules/services/xss/sanitizer.service';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';

@Injectable({
	providedIn: 'root'
})
export class AuthResolver implements Resolve<void> {
	constructor (
		private ngxAuthService: NgxAuthService,
		private route: ActivatedRoute,
		private routerService: RouterService,
		@Inject(sanitizerServiceToken) private sanitizerService: SanitizerService,
		@Inject('Window') private window: Window
	) {}

	public resolve (): Observable<void> {
		if (this.ngxAuthService.isActive()) {
			if (
				!this.route.snapshot.queryParams.invite &&
				!this.route.snapshot.queryParams.course
			) {
				if (this.route.snapshot.queryParams.redirect) {
					this.window.location.href = this.sanitizerService.isValidRedirectUrl(
						this.route.snapshot.queryParams.redirect
					)
						? this.route.snapshot.queryParams.redirect
						: '/dashboard';
				} else {
					this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_ROOT);
				}
			}
		}
		return of(void 0);
	}
}
